import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

type ContactDetailsProps = {
  ClientID: string;
  AccountNumber: string;
  PropertyAddress: string;
};

const initialState: ContactDetailsProps = {
  ClientID: "",
  AccountNumber: "",
  PropertyAddress: "",
};

export const ContactDetailsSlice = createSlice({
  name: "ContactDetails",
  initialState,
  reducers: {
    setClientID: (state, action) => {
      state.ClientID = action.payload;
    },
    setClientAccountNumber: (state, action) => {
      state.AccountNumber = action.payload;
    },
    setClientPropertyDetails: (state, action) => {
      state.PropertyAddress = action.payload;
    },
  },
});

export const selectClientID = (state: RootState) => {
  return state.clientContactDetails.ClientID;
};

export const selectClientAccountNumber = (state: RootState) => {
  return state.clientContactDetails.AccountNumber;
};

export const selectClientPropertyDetails = (state: RootState) => {
  return state.clientContactDetails.PropertyAddress;
};

export const { setClientID, setClientPropertyDetails, setClientAccountNumber } = ContactDetailsSlice.actions;
export default ContactDetailsSlice.reducer;
